import React from 'react';

import WinPopUp from '../winPopUp';
import CountDownTimer from '../countDownTimer';
import BetsClosedPopUp from '../betsClosedPopUp';
import RoundResultHexagon from '../roundResultHexagon';
import GameMachineSection from '../gameMachineSection';
import RoundResultSection from '../roundResultSection';
import GameMainBackSideLines from '../gameMainBackSideLines';

const GameMainTopSection = () => {
  return (
    <div className='monti-game-side'>
      <div className='monti-game'>
        <GameMachineSection />
        <CountDownTimer />
        <RoundResultHexagon />
        <RoundResultSection />
        <WinPopUp />
        <BetsClosedPopUp />
        <GameMainBackSideLines />
      </div>
    </div>
  );
};

export default GameMainTopSection;
